module.exports = __webpack_public_path__ + "img/arrow_drop.ff4aa1e6.svg";